// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDots_root__H9I_Q","dot":"LoadingDots_dot__jR1ii","blink":"LoadingDots_blink__q__Et"};